import { render, staticRenderFns } from "./ProductPropertyTemplateList.vue?vue&type=template&id=9b40415c&"
import script from "./ProductPropertyTemplateList.vue?vue&type=script&lang=js&"
export * from "./ProductPropertyTemplateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports